
<div :id="content ? content.idHTML : ''" :class="jel_getClassObject(content)">
  <h1 v-if="titreMessage && isAvertissement" class="grandTitre text-left">
    {{ jel_replaceTokens(titreMessage) }}
  </h1>
  <div v-if="show" class="d-inline-flex">
    <div v-if="isErreur" class="cercleErreur">
      <span class="cercleErreur-contenu">!</span>
    </div>
    <div class="d-flex" :class="isAvertissement ? 'mt-1 mb-3' : 'ml-1 mb-2'">
      <span
        :class="isAvertissement ? 'Paragraphe' : 'message-erreur'"
        v-html="jel_replaceTokens(message.msgDetail)"
      ></span>
    </div>
  </div>
</div>
